var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assets-svg-ready-1px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.75 C8.687,5.75 6,8.437 6,11.75 C6,15.063 8.687,17.75 12,17.75 C15.313,17.75 18,15.063 18,11.75 C18,8.437 15.313,5.75 12,5.75 Z M10.1853001,8.55901868 C10.6422913,8.07306845 11.2683656,7.82999992 12.0653912,7.82999992 C12.8024438,7.82999992 13.3920858,8.03794402 13.8350646,8.45327173 C14.2780435,8.86915993 14.5,9.40051035 14.5,10.0463888 C14.5,10.4383625 14.4196622,10.7557902 14.2591735,10.9996061 C14.0986847,11.2434219 13.7694866,11.6017659 13.2710186,12.0746378 C12.908938,12.4184089 12.6733428,12.7087459 12.5638592,12.9475173 C12.4543756,13.1853545 12.3996338,13.5379067 12.3996338,14.0034922 L11.4129736,14.0034922 C11.4129736,13.4751311 11.4755624,13.0497144 11.6011135,12.7263081 C11.7266647,12.4030886 12.0061655,12.0329743 12.4398027,11.6148441 L12.89231,11.1769097 C13.0279501,11.0513586 13.138181,10.9200156 13.2220686,10.7836282 C13.3752709,10.5433622 13.4520589,10.2939413 13.4520589,10.0355526 C13.4520589,9.67347201 13.341828,9.35978096 13.1206188,9.09335842 C12.9003438,8.82768321 12.5352739,8.69409827 12.0259697,8.69409827 C11.3961587,8.69409827 10.9604663,8.92334123 10.7188925,9.38164031 C10.5830655,9.63629243 10.5057171,10.0041648 10.486847,10.4843232 L9.5,10.4843232 C9.50074733,9.68673709 9.72924296,9.04440841 10.1853001,8.55901868 Z M11.5,15 L12.5,15 L12.5,16 L11.5,16 L11.5,15 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp12);
export default __webpack_public_path__ + "static/media/help-12.3930ce7e.svg";
export { ForwardRef as ReactComponent };